import React, { Component } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as appActions } from "../../modules/appModule"
import { COLOR, PATH } from "../../modules/constants"

import ForgotPasswordForm from "../../forms/ForgotPasswordForm"
import AnonPage, { Content } from "../../components/AnonPage"
import Navbar from "../../components/layout/DashboardNavbar"
import Footer from "../../components/Footer"

class ForgotPassword extends Component {
  render() {
    const { app, forgotError, portrait, urlSource } = this.props
    const href = `https://www.numerable.io/?utm_source=${urlSource}&utm_medium=numapp&utm_campaign=forgotpassword`

    return (
      <React.Fragment>
        <Navbar title="Recover Passsword" backLink portrait={portrait} />

        <AnonPage>
          <Content scroll>
            <div className="form-page">
              <div className="form-cell">
                <div className="form-wrapper">
                  <a href={href}><p className={"numerable-logo"}></p></a>
                  <p className="anon-title">I forgot my password!</p>
                  <div className="information">
                    Enter your email address below and we'll send you a confirmation code that will let you set a new password<br /><br /><br />
                  </div>
                  <ForgotPasswordForm onSubmit={form => app.forgotPassword(form)} />
                  <p className="error-message">
                    {forgotError}
                  </p>
                  <p className="alternative-link">
                    <Link to={`/${PATH.LOGIN}`} style={{ color: COLOR.BRAND.STD }} >Remembered your details? Log in</Link>
                  </p>
                </div>
              </div>
            </div>
          </Content>
        </AnonPage>

        <Footer urlSource={urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ app, common, user }) => {
  return {
    forgotError: app.forgotError,
    urlSource: common.urlSource,
    portrait: user.portrait,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)

